import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';

export default class GooglePlaceAutocompleteInput extends Component {
    static get propTypes() {
        return {
            autocompleteOptions: PropTypes.object,
            onPlaceChanged: PropTypes.func
        };
    }

    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
    }

    componentDidMount() {
        try {
            const autocompleteOptions = this.props.autocompleteOptions;
            if (this.inputRef.current) {
                this.autocomplete = new google.maps.places.Autocomplete(this.inputRef.current, {
                    types: ['address'],
                    componentRestrictions: {country: 'us'},
                    fields: ['name', 'place_id', 'formatted_address', 'address_components', 'geometry'],
                    ...autocompleteOptions
                });
                if (this.props.onPlaceChanged) {
                    this.placeChangedListener = this.autocomplete.addListener('place_changed', () => {
                        this.props.onPlaceChanged(this.inputRef.current, this.autocomplete.getPlace());
                    });
                }
            }
        } catch (e) {
            // Google Maps is not included on the page?
            console.error('Failed to initialize Google Maps Places autocomplete', e);
        }
    }

    componentWillUnmount() {
        if (this.placeChangedListener) {
            this.placeChangedListener.remove();
        }
    }

    render() {
        const {
            // eslint-disable-next-line no-unused-vars
            autocompleteOptions,
            ...inputProps
        } = this.props;
        return <input ref={this.inputRef} {...inputProps}/>;
    }
}
